import * as types from './constants.jsx';

export function getReturnDispatches(params) {
    return {
        type: types.GET_RETURN_DISPATCHES,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/`,
                method: "get",
                params
            }
        }
    };
}

export function getReturnDispatchSuppliers(params) {
    return {
        type: types.GET_RETURN_DISPATCH_SUPPLIERS,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/suppliers/`,
                method: "get",
                params
            }
        }
    };
}

export function getReturnDispatchSupplierProducts(supplierId, params) {
    return {
        type: types.GET_RETURN_DISPATCH_SUPPLIER_PRODUCTS,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/suppliers/${supplierId}/products/`,
                method: "get",
                params
            }
        }
    };
}

export function getReturnDispatchesDailySummary(params) {
    return {
        type: types.GET_RETURN_DISPATCHES_DAILY_SUMMARY,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/daily_summary/`,
                method: "get",
                params
            }
        }
    };
}

export function getSpecificReturnDispatch(id) {
    return {
        type: types.GET_SPECIFIC_RETURN_DISPATCH,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/${id}`,
                method: "get"
            }
        }
    };
}

export function approveReturnDispatch(data) {
    return {
        type: types.APPROVE_RETURN_DISPATCH,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/products/approve/`,
                method: "post",
                data
            }
        }
    };
}

export function getReturnDispatchCandidates(supplier_id, article_number) {
    return {
        type: types.GET_RETURN_DISPATCH_CANDIDATES,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/candidates/`,
                method: "get",
                params: {
                    supplier_id,
                    article_number: article_number || undefined
                }
            }
        }
    };
}

export function getReturnDispatchPendingSuppliers() {
    return {
        type: types.GET_RETURN_DISPATCH_PENDING_SUPPLIERS,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/pending_suppliers/`,
                method: "get"
            }
        }
    };
}

export function createReturnDispatch(data) {
    return {
        type: types.CREATE_RETURN_DISPATCH,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/`,
                method: "post",
                data
            }
        }
    };
}

export function offerToStock(data) {
    return {
        type: types.OFFER_TO_STOCK,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/offer_to_stock/`,
                method: "post",
                data
            }
        }
    };
}

export function offerReturnDispatchProductToStock(data) {
    return {
        type: types.OFFER_RETURN_DISPATCH_PRODUCT_TO_STOCK,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/products/offer_to_stock/`,
                method: "post",
                data
            }
        }
    };
}

export function processReturnDispatchStatus(data) {
    return {
        type: types.PROCESS_RETURN_DISPATCH_STATUS,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/return_dispatches/process_status/`,
                method: "patch",
                data
            }
        }
    };
}
